import queryStringify from './query-stringify';
import config from '../config';

class SearchAssociatesUrls {
  constructor() {
    this.options = {
      baseUrl:
        (config.searchAssociatesSite.secure ? 'https://' : 'http://') +
        config.searchAssociatesSite.host +
        config.searchAssociatesSite.path
    };
  }

  generate(path, query = null) {
    let preparedUrl = `${this.getBaseUrl()}${path}`;

    if (query) {
      preparedUrl += `?${queryStringify(query)}`;
    }

    return preparedUrl;
  }

  getBaseUrl() {
    return this.options.baseUrl;
  }

  editSchoolProfile() {
    return this.generate('School/Profile.aspx');
  }

  editSchoolUserAccount() {
    return this.generate('School/MyAccount.aspx');
  }

  editCandidateProfile() {
    return this.generate('Candidate/MyProfile.aspx');
  }

  editCandidateReferences() {
    return this.generate('Candidate/ConfidentialReferences.aspx');
  }

  retrievePassword() {
    return this.generate('ForgotPassword.aspx');
  }

  searchAssociatesCandidates() {
    return this.generate('Candidates/Candidates.aspx');
  }

  syncCookiePage() {
    return this.generate('API/SyncSharedAuthTokenCookie.html');
  }

  partnerProfile(partnerAccountSearchAssociatesId) {
    return this.generate('School/Candidate.aspx', {
      ID: partnerAccountSearchAssociatesId
    });
  }
}

export default new SearchAssociatesUrls();



// WEBPACK FOOTER //
// ./src/tools/search-associates-urls.js